// extracted by mini-css-extract-plugin
export default {"errorTextWrapper":"error-message_errorTextWrapper__50dx0","errorText":"error-message_errorText__BMXNB"};